import { Dialog, DialogContent, Typography, Button } from "@mui/material";
import AppStoreLinks from "./AppStoreLinks";

const STORE_LABELS = {
  googlePlay: "Get it on Google Play (opens in a new tab)",
  appStore: "Download on the App Store (opens in a new tab)",
  qrGooglePlay: "QR code for Echo on Google Play",
  qrAppStore: "QR code for Echo on the App Store",
};

const ConnectButtonModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="connect-modal-title"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "20px",
          maxWidth: "400px",
          textAlign: "center",
        },
      }}
    >
      <DialogContent>
        {/* Heading */}
        <Typography
          id="connect-modal-title"
          variant="h5"
          sx={{ fontWeight: 700, color: "#2A4876", mb: 2 }}
        >
          Visit Our Mobile App!
        </Typography>

        {/* Body */}
        <Typography
          sx={{
            fontSize: "15.5px",
            mb: 3,
            lineHeight: 1.6,
            color: "#2A4876",
            textAlign: "left",
          }}
        >
          Please visit the Echo mobile app to start or manage mentoring
          relationships.
        </Typography>

        <AppStoreLinks labels={STORE_LABELS} />

        {/* Close Button */}
        <Button
          onClick={onClose}
          sx={{
            mt: 4,
            backgroundColor: "#2A4876",
            color: "#fff",
            textTransform: "none",
            borderRadius: "50px",
            px: 4,
            "&:hover": { backgroundColor: "#1e365c" },
          }}
        >
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ConnectButtonModal;
